export var COLLECT_USER_INFO_FIELD = /* @__PURE__ */ ((COLLECT_USER_INFO_FIELD2) => {
  COLLECT_USER_INFO_FIELD2["EMAIL"] = "email";
  COLLECT_USER_INFO_FIELD2["FIRST_NAME"] = "first_name";
  COLLECT_USER_INFO_FIELD2["LAST_NAME"] = "last_name";
  return COLLECT_USER_INFO_FIELD2;
})(COLLECT_USER_INFO_FIELD || {});
export var PRODUCT_CHOICE_PRODUCT_SOURCE = /* @__PURE__ */ ((PRODUCT_CHOICE_PRODUCT_SOURCE2) => {
  PRODUCT_CHOICE_PRODUCT_SOURCE2["AI_RECOMMENDATIONS"] = "ai_recommendations";
  PRODUCT_CHOICE_PRODUCT_SOURCE2["POPULAR_PRODUCTS"] = "popular_products";
  PRODUCT_CHOICE_PRODUCT_SOURCE2["RECENTLY_VIEWED"] = "recently_viewed";
  PRODUCT_CHOICE_PRODUCT_SOURCE2["MANUAL"] = "manual";
  return PRODUCT_CHOICE_PRODUCT_SOURCE2;
})(PRODUCT_CHOICE_PRODUCT_SOURCE || {});
export var PURCHASE_OFFER_CART_SOURCE = /* @__PURE__ */ ((PURCHASE_OFFER_CART_SOURCE2) => {
  PURCHASE_OFFER_CART_SOURCE2["MANUAL"] = "manual";
  PURCHASE_OFFER_CART_SOURCE2["LATEST_CART"] = "latest_cart";
  return PURCHASE_OFFER_CART_SOURCE2;
})(PURCHASE_OFFER_CART_SOURCE || {});
